import {Container, Typography} from "@material-ui/core";
import React from "react";
import ConvertToLatex from "../../../helper/ConvertToLatex";
import ReactHtmlParser from "react-html-parser";
import {questionTypes} from "../../../../config/constants";
import CustomSweetAlert from "../../../helper/CustomSweetAlert";
import getErrorMessage from "../../../../config/ErrorMessage";
import TextInputQuestionDetail from "./TextInputQuestionDetail";
import MultipleChoiceQuestionDetail from "./MultipleChoiceQuestionDetail";
import GroupQuestionDetail from "./GroupQuestionDetail";
import NoAnswerQuestionDetail from "./NoAnswerQuestionDetail";
import i18n from 'i18next';

const QuestionDetail = (props) => {
    const {testTypeId, question, index} = props;
    let answersComponent = null;
    switch (question.questionType) {
        case questionTypes.MULTIPLE_CHOICE:
        case questionTypes.COMBO_BOX:
            answersComponent = <MultipleChoiceQuestionDetail key={question.questionCode} question={question} testTypeId={testTypeId}/>;
            break;
        case questionTypes.TEXT_INPUT:
            answersComponent = <TextInputQuestionDetail key={question.questionCode} question={question} testTypeId={testTypeId}/>;
            break;
        case questionTypes.NO_ANSWERS:
            answersComponent = <NoAnswerQuestionDetail question={question} index={index} testTypeId={testTypeId}/>;
            break;
        case questionTypes.GROUP_QUESTION:
            answersComponent = <GroupQuestionDetail question={question} index={index} testTypeId={testTypeId}/>;
            break;
        default:
            answersComponent =
                <CustomSweetAlert showConfirm={false} text={getErrorMessage("QUESTION_TYPE_NOT_FOUND")}/>;
            break;
    }

    return (
        <Container maxWidth={false} style={{margin: 0, padding: 10}}>
            <div className="question-content">
                {question.content ?
                    question.content.search("latex") !== -1 ?
                        <Typography
                            style={{paddingBottom: 20}}
                            variant="h6"><b>{i18n.t('question')} {index} : </b>
                            <ConvertToLatex textInput={question.content}/>
                        </Typography> :
                        <Typography
                            variant="h6"><b>{i18n.t('question')} {index}:</b> {ReactHtmlParser(question.content)}
                        </Typography> : ""
                }
                {answersComponent}
            </div>
        </Container>
    );
};

export default QuestionDetail;
